import NovedadesManager from '../../../Common/Managers/NovedadesManager';
import EstadoManager from '../../../Common/Managers/EstadoManager';
import BajaCuentaTarjetaManager from '../../../Common/Managers/BajaCuentaTarjetaManager';

//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import saldosResumenes from '../../../Store/Reducers/SaldosResumenes';
import ingresoAjustes from '../../../Store/Reducers/IngresoAjustes';
import ingresoCobranzas from '../../../Store/Reducers/IngresoCobranzas';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const INITIAL_STATE_PANEL_SELECCION = 'INITIAL_STATE_PANEL_SELECCION';
export const GET_PANEL_SELECCION_DATA = 'GET_PANEL_SELECCION_DATA';
export const RETURN_VISTA_CLIENTE = 'RETURN_VISTA_CLIENTE';
export const CHANGE_INPUT_PANEL = 'CHANGE_INPUT_PANEL';
export const SELECT_COMBO_PANEL = 'SELECT_COMBO_PANEL';
export const GET_CUENTA_DATA_PANEL = 'GET_CUENTA_DATA_PANEL';
export const GET_EMPRESA_DATA_PANEL = 'GET_EMPRESA_DATA_PANEL';
export const CHANGE_DATES_EMPRESA_PANEL = 'CHANGE_DATES_EMPRESA_PANEL';
export const CHANGE_DATES_CUENTA_PANEL = 'CHANGE_DATES_CUENTA_PANEL';
export const CHANGE_DATES_TARJETA_PANEL = 'CHANGE_DATES_TARJETA_PANEL';
export const GET_DOMICILIOS_PANEL = 'GET_DOMICILIOS_PANEL';
export const MOSTRAR_COMPONENTE_PANEL = 'MOSTRAR_COMPONENTE_PANEL';
export const CHANGE_CHECK_PANEL = 'CHANGE_CHECK_PANEL';
export const SAVE_NOVEDAD_PANEL = 'SAVE_NOVEDAD_PANEL';
export const CANCEL_NOVEDAD_PANEL = 'CANCEL_NOVEDAD_PANEL';
export const CHANGE_DATE_PANEL = 'CHANGE_DATE_PANEL';
export const CHANGE_DATE_ERROR_PANEL = 'CHANGE_DATE_ERROR_PANEL';
export const ESTADO_EDICION_PANEL = 'ESTADO_EDICION_PANEL';
export const FILTRO_RUBROS_EMPRESA_PANEL = 'FILTRO_RUBROS_EMPRESA_PANEL';
export const CHANGE_RUBRO_EMPRESA_PANEL = 'CHANGE_RUBRO_EMPRESA_PANEL';
export const GUARDAR_CAMPO_PANEL = 'GUARDAR_CAMPO_PANEL';
export const GET_CUENTAS_SUCURSALES_PANEL = 'GET_CUENTAS_SUCURSALES_PANEL';
export const ESTA_GUARDANDO_PANEL = 'ESTA_GUARDANDO_PANEL';
export const CHANGE_TEXT = 'CHANGE_TEXT';
export const CHANGE_EDIT_VIEW = 'CHANGE_EDIT_VIEW';
export const GET_TARJETAS_DATA_PANEL = 'GET_TARJETAS_DATA_PANEL';
export const BLOQUEAR_TARJETA = 'BLOQUEAR_TARJETA';
export const MOSTRAR_MODAL = "MOSTRAR_MODAL";
export const ACTUALIZAR_ESTADO_NOVEDAD = "ACTUALIZAR_ESTADO_NOVEDAD";
export const GET_NOVEDADES_BY_ID_AND_CODIGO = 'GET_NOVEDADES_BY_ID_AND_CODIGO';
export const MOSTRAR_SPINNER = "MOSTRAR_SPINNER";
export const MOSTRAR_SALDOS_RESUMENES = 'MOSTRAR_SALDOS_RESUMENES';
export const MOSTRAR_INGRESO_AJUSTES = 'MOSTRAR_INGRESO_AJUSTES';
export const MOSTRAR_INGRESO_COBRANZAS = 'MOSTRAR_INGRESO_COBRANZAS';
export const GET_DIAS_VIGENCIA_PANEL = 'GET_DIAS_VIGENCIA_PANEL';
export const CHANGE_ENTIDAD_TARJETA_PANEL = 'CHANGE_ENTIDAD_TARJETA_PANEL';
export const MOSTRAR_MODAL_BAJA_CUENTA = 'MOSTRAR_MODAL_BAJA_CUENTA';
export const OCULTAR_MODAL_BAJA_CUENTA = 'OCULTAR_MODAL_BAJA_CUENTA';
export const VALOR_TEXT_AREA = 'VALOR_TEXT_AREA';
export const VALOR_SELECT = 'VALOR_SELECT';
export const REALIZAR_BAJA_CUENTA_BAJA_CUENTA = 'REALIZAR_BAJA_CUENTA_BAJA_CUENTA';
export const OCULTAR_SPINNER_PANEL_SELECCION = 'OCULTAR_SPINNER_PANEL_SELECCION';
export const CHECK_SOLICITAR_CAIDA_CUOTAS = 'CHECK_SOLICITAR_CAIDA_CUOTAS';
export const NUMERO_BAJA_CUENTA = 'NUMERO_BAJA_CUENTA';

let _dispatch, _tarjetas, _vistaCliente, _cliente, _seleccion, _params, _productId = null;
let funcionesDelUsuario = [];
let _currentScope;
const estadoId = 1;
const novedadesDirectas = ["ESCON_EMPR", "LIDFT_CUEN", "ESTEM_TARJ", "VIGER_TARJ"];
/**
 * Action que obtiene el estado inicial con el cliente recibido por routeState.
 * @param {any} cliente
 * @param {any} currentScope
 */
export function getScreenData(currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        _tarjetas = JSON.parse(JSON.stringify(state.tarjetas));
        _currentScope = JSON.parse(JSON.stringify(currentScope));

        /*Se obtienen las funciones del usuario para el feature CARGACOBRANZA*/
        let permisosCobranza = {}
        if (_currentScope.CARGACOBRANZA) {
            _currentScope.CARGACOBRANZA.forEach(p => permisosCobranza[p.Codigo_Funcion] = true);
            _currentScope.CARGACOBRANZA = permisosCobranza;
        }

        /*Se obtienen las funciones del usuario para el feature CARGAAJUSTE*/
        let permisosAjuste = {}
        if (_currentScope.CARGAAJUSTES) {
            _currentScope.CARGAAJUSTES.forEach(p => permisosAjuste[p.Codigo_Funcion] = true);
            _currentScope.CARGAAJUSTES = permisosAjuste;
        }

        _dispatch = dispatch;
        _seleccion = "inicial";

        /*Se obtienen las funciones del usuario para el feature ADMINEMPCUETAR*/
        currentScope.ADMINEMPCUETAR.forEach(admect => {
            funcionesDelUsuario[admect.Codigo_Funcion] = true
        });

        switch (_vistaCliente.data.entidadTipo) {
            case 0:
                _loadEmpresaData(state, _vistaCliente.data.idEntidad);
                break;
            case 1:
                _loadCuentaData(state, _vistaCliente.data.idEntidad);
                break;
            case 2:
                _loadTarjetaData(state, _vistaCliente.data.idEntidad);
                break;
        }
    }
}

/** 
 * Action que obtiene el estado inicial.
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_PANEL_SELECCION });
    }
}

/** 
 *
 */
export function valorTextArea(txtArea) {
    LogHelper.In(valorTextArea.name, txtArea);

    return (dispatch) => {
        dispatch({ type: VALOR_TEXT_AREA, txtArea: txtArea });
    }
}

/** 
 *
 */
export function valorSelect(id) {
    LogHelper.In(valorSelect.name, id);

    return (dispatch) => {
        dispatch({ type: VALOR_SELECT, id: id });
    }
}

/** 
 *
 */
export function changeCheckSolicitarCaidaCuotas() {
    LogHelper.In(changeCheckSolicitarCaidaCuotas.name);

    return (dispatch) => {
        dispatch({ type: CHECK_SOLICITAR_CAIDA_CUOTAS });
    }
}

/**
 * Cambia el texto del Limite en Empresa y Cuenta
 * @param {any} estado
 */
export function changeText(estado) {
    LogHelper.In(changeText.name, estado);

    return (dispatch) => {
        dispatch({ type: CHANGE_TEXT, estado: estado });
    }
}

/**
 * Muestra el componente de editado del Limite en Empresa y Cuenta
 * @param {any} estado
 */
export function changeEditView(estado) {
    LogHelper.In(changeEditView.name, estado);

    return (dispatch) => {
        dispatch({ type: CHANGE_EDIT_VIEW, estado: estado });
    }

}

/**
 * Action que obtiene el estado inicial con el cliente recibido por routeState.
 * @param {any} cliente
 * @param {any} currentScope
 */
export function redirectVistaCliente() {
    LogHelper.In(redirectVistaCliente.name);

    return (dispatch, getState) => {

        _dispatch({
            type: RETURN_VISTA_CLIENTE
        });
    }
}

/**
 * Obtiene los datos de la cuenta seleccionada
 * @param {any} id
 */
export function getCuentaData(id) {
    LogHelper.In(getCuentaData.name, id);

    return (dispatch, getState) => {
        let state = getState();
        _dispatch = dispatch;
        _seleccion = "interno";
        _loadCuentaData(state, id);
    }
}

/**
 * Obtiene los saldos y resumenes de la cuenta seleccionada
 * @param {any} id
 */
export function getSaldosResumenesData(id) {
    LogHelper.In(getSaldosResumenesData.name, id);

    return (dispatch, getState) => {
        _seleccion = "interno";
        const reducers = [];
        reducers.push(saldosResumenes);

        _dispatch({ type: 'STORE_INJECT', reducers: reducers });
        _dispatch({ type: MOSTRAR_SALDOS_RESUMENES, id });
    }
}

/**
 * Obtiene los ingresos de ajustes de la cuenta seleccionada
 * @param {any} id
 */
export function getIngresoAjustesData(id) {
    LogHelper.In(getIngresoAjustesData.name, id);

    return (dispatch, getState) => {
        _seleccion = "interno";
        _dispatch({ type: MOSTRAR_INGRESO_AJUSTES, id });
    }
}

/**
 * Obtiene los ingresos de cobranzas de la cuenta seleccionada
 * @param {any} id
 */
export function getIngresoCobranzasData(id) {
    LogHelper.In(getIngresoCobranzasData.name, id);

    return (dispatch, getState) => {
        _seleccion = "interno";
        _dispatch({ type: MOSTRAR_INGRESO_COBRANZAS, id });
    }
}

/**
 * Obtiene los datos de las tarjetas de la cuenta seleccionada
 * @param {any} id
 */
export function getTarjetaData(cuentaTarjetaId) {
    LogHelper.In(getTarjetaData.name, cuentaTarjetaId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _seleccion = "interno";
        _loadTarjetaData(getState(), cuentaTarjetaId);
    }
}

/**
 * Obtiene los datos de la empresa seleccionada
 * @param {any} id
 */
export function getEmpresaData(id) {
    LogHelper.In(getEmpresaData.name, id);

    return (dispatch, getState) => {
        let state = getState();
        _dispatch = dispatch;
        _seleccion = "interno";
        _loadEmpresaData(state, id);
    }
}

/**
 * Cambia el estado de la edicion
 * @param {any} id
 */
export function estadoEdicion(estado, componente) {
    LogHelper.In(estadoEdicion.name, estado, componente);

    return (dispatch, getState) => {

        _dispatch({
            type: ESTADO_EDICION_PANEL,
            estado: estado,
            componente: componente
        });
    }
}

/**
 * Abre modal baja de cuenta
 */
export function openModalBajaCuenta() {
    LogHelper.In(openModalBajaCuenta.name);

    return (dispatch, getState) => {

        _dispatch({
            type: MOSTRAR_MODAL_BAJA_CUENTA
        });
    }
}

/**
 * Cierra modal baja de cuenta
 */
export function closeModalBajaCuenta() {
    LogHelper.In(closeModalBajaCuenta.name);

    return (dispatch, getState) => {

        _dispatch({
            type: OCULTAR_MODAL_BAJA_CUENTA
        });
    }
}

/**
 * Cierra modal baja de cuenta
 */
export function realizarBajaCuentaTarjeta() {
    LogHelper.In(realizarBajaCuentaTarjeta.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();

        const saldoALaBaja = state.panelSeleccion.data.cuentaDatos.bajaCuentaData.bajaCuenta12.SaldoTotal;
        const cuentaDatos = state.panelSeleccion.data.cuentaDatos;

        const { executionContext } = state.sesion;
        let cuentaTarjeta = {};
        cuentaTarjeta.Id = cuentaDatos.CuentaTarjetaId;
        cuentaTarjeta.SucursalPedidoId = state.menuProductos.branchId;
        cuentaTarjeta.TipoBaja = saldoALaBaja == 0 ? 0 : 1;
        cuentaTarjeta.MotivoBajaId = state.panelSeleccion.data.motivoBajaId;
        cuentaTarjeta.SolicitaCaidaCuota = state.panelSeleccion.data.checkSolcitarCaidaCuotas ? 1 : 0;
        cuentaTarjeta.Comentarios = state.panelSeleccion.data.valorTxtArea;
        cuentaTarjeta.SaldoALaBaja = saldoALaBaja;
        cuentaTarjeta.UsuarioLogin = executionContext.login;
        cuentaTarjeta.Terminal = executionContext.terminalId;

        dispatch({ type: MOSTRAR_SPINNER });

        BajaCuentaTarjetaManager.BajaCuentaTarjeta(cuentaTarjeta, viewCallback);
    }
}

function viewCallback(bajaId) {
    _dispatch({
        type: NUMERO_BAJA_CUENTA,
        bajaId: bajaId
    });
    _dispatch({
        type: OCULTAR_SPINNER_PANEL_SELECCION
    });
}

/**
 * 
 * @param {any} novedadRecibida
 * @param {any} form
 * @param {any} params
 */
export function guardarNovedad(novedadRecibida, form, ...params) {
    LogHelper.In(guardarNovedad.name, novedadRecibida, form);

    return (dispatch, getState) => {
        const state = getState();

        _dispatch({ type: ESTA_GUARDANDO_PANEL });

        let puedeGuardar = false;
        let valorAnteriorState = state.panelSeleccion.data.valorAnterior != undefined ? true : false
        let valorDataPickerSeleccionadoState = state.panelSeleccion.data.valorDataPickerSeleccionado != undefined ? true : false
        let valorSelectIdSeleccionadoState = state.panelSeleccion.data.valorSelectIdSeleccionado != undefined ? true : false

        //Valida si no modifico componente y quiere guardar novedad
        if (valorAnteriorState) {
            puedeGuardar = true;
        }
        else {
            if (valorDataPickerSeleccionadoState) {
                puedeGuardar = true;
            }
            else {
                if ((valorSelectIdSeleccionadoState && (/\d/g).test(novedadRecibida))) {
                    puedeGuardar = true;
                }
            }
        }

        const { componenteSeleccionado, entidadTipo } = state.panelSeleccion.data;
        if (puedeGuardar) {
            let novedad = {};
            let novedades = [];
            let novedadTipo;
            let novedadObtenidaId = null;
            let novedadObtenida;
            let novedadAnterior = state.panelSeleccion.data.valorAnterior;
            let novedadRecibidaId = state.panelSeleccion.data.valorSelectIdSeleccionado;
            let novedadDataPickerRecibido = state.panelSeleccion.data.valorDataPickerSeleccionado;

            const { executionContext } = state.sesion;

            switch (entidadTipo) {
                /*Empresa*/
                case 0: {
                    const { empresaDatos, novedadesEmpresaDatos } = state.panelSeleccion.data;

                    novedadTipo = 3;
                    novedadObtenida = novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == componenteSeleccionado && x.NovedadEstadoId < 4);

                    if (novedadObtenida) {
                        novedadObtenidaId = novedadObtenida.Id;
                        novedadAnterior = novedadObtenida.ValorAnterior;
                    }

                    novedad.EmpresaVisaId = empresaDatos.Id;
                    break;
                }
                /*Cuenta*/
                case 1: {
                    const { cuentaDatos, novedadesCuentaDatos } = state.panelSeleccion.data;
                    novedadTipo = 1;
                    novedadObtenida = novedadesCuentaDatos.find(x => x.NovedadCampoCodigo == componenteSeleccionado && x.NovedadEstadoId < 4);

                    if (novedadObtenida) {
                        novedadObtenidaId = novedadObtenida.Id;
                        novedadAnterior = novedadObtenida.ValorAnterior;
                    }

                    novedad.CuentaTarjetaId = cuentaDatos.Id;

                    //Comprueba si el componente seleccionado es el Domicilio Particular y guarda el codigo geografico
                    if (componenteSeleccionado == "DOMPA_CUEN") {
                        if (cuentaDatos.DomicilioParticularCodigoGeografico == "0") {
                            novedadRecibida = cuentaDatos.DomicilioParticularCodigoGeograficoInput;
                        } else {
                            novedadRecibida = cuentaDatos.DomicilioParticularCodigoGeografico;
                        }
                    }

                    break;
                }
                /*Tarjeta*/
                case 2: {
                    const { cuentaDatos, novedadesTarjetaDatos } = state.panelSeleccion.data;
                    novedadTipo = 2;

                    novedadObtenida = novedadesTarjetaDatos.find(x => x.NovedadCampoCodigo == componenteSeleccionado
                        && x.TarjetaCreditoId == params[0]
                        && x.CuentaTarjetaId == cuentaDatos.Id
                        && x.NovedadEstadoId < 4);

                    if (novedadObtenida) {
                        novedadObtenidaId = novedadObtenida.Id;
                        novedadAnterior = novedadObtenida.ValorAnterior;
                    }

                    novedad.TarjetaCreditoId = params[0];
                    novedad.CuentaTarjetaId = state.panelSeleccion.data.cuentaDatos.Id;
                    break;
                }
            }

            let checkNovedadRecibida = novedadRecibidaId ? novedadRecibidaId :
                novedadDataPickerRecibido ? novedadDataPickerRecibido : comprobarNovedad(novedadRecibida)

            let checkNovedadAnterior = novedadRecibidaId ? novedadAnterior :
                novedadDataPickerRecibido ? convertirFecha(novedadAnterior) : comprobarNovedad(novedadAnterior)

            novedad = {
                ...novedad,
                Tipo: novedadTipo,
                Id: novedadObtenidaId,
                Codigo: state.panelSeleccion.data.componenteSeleccionado,
                ValorAnterior: checkNovedadAnterior,
                ValorNovedad: checkNovedadRecibida,
                UsuarioLogin: executionContext.login,
                Terminal: executionContext.terminalId,
                tipoEntidad: entidadTipo
            }

            const novedadDirecta = novedadesDirectas.some(x => x == novedad.Codigo);
            if (novedadDirecta) {
                novedad.EstadoId = 5;
                impactarNovedad(novedad, state.panelSeleccion.data);
            } else {
                novedad.EstadoId = estadoId;
            }

            novedades.push(novedad);
            NovedadesManager.GuardarNovedades(novedades, () => callBackGuardarNovedad(state));
        }
        else {
            _dispatch({
                type: CANCEL_NOVEDAD_PANEL,
                entidadId: entidadTipo
            });
        }
    }
}
/**
 * Genera o actualiza una novedad
 * @param {any} novedadRecibida Parametro tipo JSON, contiene toda la informacion de la novedad a generar/actualizar
 * @param {any} componenteSeleccionado Componente seleccionado
 */
export function guardarNovedadBloqueo(novedad) {
    LogHelper.In(guardarNovedadBloqueo.name, novedad);

    return (dispatch, getState) => {
        dispatch({ type: MOSTRAR_SPINNER });

        let state = getState();

        const { executionContext } = state.sesion;

        let novedades = [{
            Tipo: 2,
            Id: novedad.Id,
            Codigo: novedad.NovedadCampoCodigo,
            ValorAnterior: novedad.ValorAnterior,
            ValorNovedad: novedad.ValorNovedad,
            UsuarioLogin: executionContext.login,
            Terminal: executionContext.terminalId,
            EstadoId: novedad.EstadoId,
            tipoEntidad: 2,
            TarjetaCreditoId: novedad.TarjetaCreditoId,
            CuentaTarjetaId: novedad.CuentaTarjetaId
        }];

        NovedadesManager.GuardarNovedades(novedades, () => callBackGuardarNovedad(state));
    }
}

/**
 * 
 * @param {any} novedadesRecibidas
 */
export function guardarNovedades(novedadesRecibidas) {
    LogHelper.In(guardarNovedades.name, novedadesRecibidas);

    return (dispatch, getState) => {

        dispatch({ type: MOSTRAR_SPINNER });

        //MODIFICAR LOGICA PARA GUARDAR NOVEDADES, SI NO MODIFICO NADA Y PRESIONO EL BOTON LISTO
        //Valida si no modifico componente y quiere guardar novedades
        let i = 0;
        novedadesRecibidas.map(function (row) {
            if (row.ValorNuevo == "") {
                i = i + 1;
            }
        });

        let state = getState();

        if (i < 2 || state.panelSeleccion.data.componenteSeleccionado == "RUBRO_EMPR") {
            _dispatch = dispatch;
            const { data } = state.panelSeleccion;
            const { executionContext } = state.sesion;

            let novedades = [];
            let novedadTipo;
            let nombreCampoNovedades = "";

            switch (state.panelSeleccion.data.entidadTipo) {
                //Empresa
                case 0: {
                    novedadTipo = 3;
                    nombreCampoNovedades = "novedadesEmpresaDatos";
                    break;
                }
                //Cuenta
                case 1: {
                    novedadTipo = 1;
                    nombreCampoNovedades = "novedadesCuentaDatos";
                    break;
                }
            }

            novedadesRecibidas.forEach(nr => {
                const ne = data[nombreCampoNovedades].find(ncd => ncd.NovedadCampoCodigo == nr.Clave && ncd.NovedadEstadoId < 4);
                if (ne) {
                    nr.Id = ne.Id
                }
            });

            novedadesRecibidas.forEach(function (nr) {
                let novedadNueva = {
                    Tipo: novedadTipo,
                    Id: nr.Id,
                    Codigo: nr.Clave,
                    ValorAnterior: nr.ValorAnterior,
                    ValorNovedad: nr.ValorNuevo,
                    UsuarioLogin: executionContext.login,
                    Terminal: executionContext.terminalId,
                    tipoEntidad: state.panelSeleccion.data.entidadTipo
                }

                switch (state.panelSeleccion.data.entidadTipo) {
                    /*Empresa*/
                    case 0: {
                        novedadNueva.EmpresaVisaId = state.panelSeleccion.data.empresaDatos.Id;
                        break;
                    }
                    /*Cuenta*/
                    case 1: {
                        novedadNueva.CuentaTarjetaId = state.panelSeleccion.data.cuentaDatos.Id;
                        break;
                    }
                }

                const novedadDirecta = novedadesDirectas.some(x => x == novedadNueva.Codigo);

                if (novedadDirecta) {
                    novedadNueva.EstadoId = 5;
                    impactarNovedad(novedadNueva, state.panelSeleccion.data);
                } else {
                    novedadNueva.EstadoId = estadoId;
                }

                novedades.push(novedadNueva);
            });

            NovedadesManager.GuardarNovedades(novedades, () => callBackGuardarNovedad(state));
        }
        else {
            _dispatch({
                type: CANCEL_NOVEDAD_PANEL
            });
        }
    }
}

/**
 * 
 */
export function cancelar() {
    LogHelper.In(cancelar.name);

    //COMPLETAR FUNCION
    return (dispatch, getState) => {
        let state = getState();
        _dispatch = dispatch;
        dispatch({
            type: CANCEL_NOVEDAD_PANEL,
            entidadId: state.panelSeleccion.data.entidadTipo
        });
    }
}
/**
 * 
 * @param {any} typeInput
 * @param {any} isCheck
 */
export function filtroRubro(typeInput, isCheck) {
    LogHelper.In(filtroRubro.name, typeInput, isCheck);

    return (dispatch) => {
        dispatch({
            type: FILTRO_RUBROS_EMPRESA_PANEL,
            typeInput: typeInput,
            isCheck: isCheck
        });
    }
}
/**
 * 
 * @param {any} typeFilter
 * @param {any} term
 */
export function changeRubro(valueBuscador, select) {
    LogHelper.In(changeRubro.name, valueBuscador, select);

    return (dispatch) => {
        dispatch({
            type: CHANGE_RUBRO_EMPRESA_PANEL,
            valueBuscador: valueBuscador,
            select: select
        });
    }
}
/**
 * 
 * @param {any} action
 * @param {any} id
 */
export function selectCombo(entidadId, action, id, ...params) {
    LogHelper.In(selectCombo.name, entidadId, action, id);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: SELECT_COMBO_PANEL,
            entidadId: entidadId,
            componente: action,
            id: id,
            params
        });
    }
}
/**
 * 
 * @param {any} action
 * @param {any} id
 */
export function changeDate(entidadId, action, value) {
    LogHelper.In(changeDate.name, entidadId, action, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_DATE_PANEL,
            entidadId: entidadId,
            componente: action,
            value: value
        });
    }
}
/**
 * 
 */
export function changeDataError() {
    LogHelper.In(changeDataError.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_DATE_ERROR_PANEL
        });
    }
}
/**
 * 
 * @param {any} action
 * @param {any} value
 */
export function changeInput(entidadId, action, value, ...params) {
    LogHelper.In(changeInput.name, entidadId, action, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_INPUT_PANEL,
            entidadId: entidadId,
            componente: action,
            value: value,
            id: params[0],
            parametros: params
        });
    }
}

/**
 * 
 * @param {any} action
 * @param {any} value
 */
export function changeCheck(entidadId, action, value, ...params) {
    LogHelper.In(changeCheck.name, entidadId, action, value);

    let evento;
    switch (value) {
        case "false":
            evento = true;
            break;
        case "true":
            evento = false;
            break;
        case "NO":
            evento = true;
            break;
        case "SI":
            evento = false;
            break;
    }

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({
            type: CHANGE_CHECK_PANEL,
            entidadId: entidadId,
            componente: action,
            value: evento,
            id: params[0]
        });
    }
}
/**
 * 
 * @param {any} componente
 * @param {any} value
 * @param {any} params
 */
export function mostrarComponente(componente, value, ...params) {
    LogHelper.In(mostrarComponente.name, componente, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: MOSTRAR_COMPONENTE_PANEL, componente, value, params });
    }
}
/**
 * 
 * @param {any} value
 */
export function bloquearTarjeta(value) {
    LogHelper.In(bloquearTarjeta.name, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: BLOQUEAR_TARJETA, value });
    }
}
/**
 * 
 * @param {any} mostrar
 */
export function mostrarModal(mostrar, tituloCampo, entidadTipoId, novedadCampoCodigo, entidadId) {
    LogHelper.In(mostrarModal.name, mostrar);

    return (dispatch) => {
        dispatch({ type: MOSTRAR_MODAL, mostrar, tituloCampo, novedadCampoCodigo });

        if (mostrar) {
            getNovedadesByIdAndCodigo(entidadTipoId, novedadCampoCodigo, entidadId)
        }
    }
}
/**
 * 
 * @param {any} novedadId
 * @param {any} estadoId
 * @param {any} novedadTipoId
 * @param {any} entidadId
 */
export function actualizarNovedadEstado(novedadId, estadoId, novedadCodigo, novedadTipoId, entidadId) {
    LogHelper.In(actualizarNovedadEstado.name, novedadId, estadoId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();
        const { executionContext } = state.sesion;
        let novedad = {};
        let novedades = [];
        novedad.Id = novedadId;
        novedad.Codigo = novedadCodigo;
        novedad.UsuarioLogin = executionContext.login;
        novedad.Terminal = executionContext.terminalId;
        novedades.push(novedad);

        dispatch({ type: MOSTRAR_SPINNER });

        EstadoManager.CambiarEstadoNovedad(novedad, estadoId, () => {
            getNovedadesByTipoAndId(novedadTipoId, entidadId);
        });
    }
}
/**
 * 
 * @param {any} novedades
 * @param {any} estadoId
 * @param {any} novedadTipoId
 * @param {any} entidadId
 */
export function actualizarNovedadEstados(novedades, estadoId, novedadTipoId, entidadId) {
    LogHelper.In(actualizarNovedadEstados.name, novedades, estadoId, novedadTipoId, entidadId);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        const state = getState();
        const { executionContext } = state.sesion;

        dispatch({ type: MOSTRAR_SPINNER });

        let novedadSession = {
            'UsuarioLogin': executionContext.login,
            'Terminal': executionContext.terminalId
        }

        EstadoManager.CambiarEstadosNovedad(novedades, novedadSession, estadoId, () => {
            getNovedadesByTipoAndId(novedadTipoId, entidadId);
        });
    }
}

export function getDiasVigencia() {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

        Engine1Proxy.Execute((data) => {
            let vigencias = JSON.parse(data.GET_VIGENCIA_TARJETA).Recordset0.Rows;
            _dispatch({ type: GET_DIAS_VIGENCIA_PANEL, vigencias })
        }, null, "ADMINEMPCUETAR");
    }
}
///** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/
function impactarNovedad(novedad, data) {
    LogHelper.In(impactarNovedad.name, novedad, data);
    let localValues;
    let isQuery = false;
    let deleteInstance = false;
    let evtSrc = '';
    let idEntidad = 0
    switch (novedad.Codigo) {
        case "ESCON_EMPR":
            idEntidad = novedad.EmpresaVisaId;
            evtSrc = 'EVENTSOURCING_TRANSACTION_EMPRESA_VISA';
            localValues = {
                'ES_CONFIDENCIAL': novedad.ValorNovedad
            }
            break;

        case "LIDFT_CUEN":
            idEntidad = data.cuentaDatos.IdCuentaTarjetaVisa;
            evtSrc = 'EVENTSOURCING_TRANSACTION_CUENTA_TARJETA_VISA';
            localValues = {
                'LIMITE_DEFAULT_TARJETAS': novedad.ValorNovedad
            }
            break;

        case "ESTEM_TARJ":
            idEntidad = data.tarjetasDatos.find(x => x.TarjetaCreditoId == novedad.TarjetaCreditoId).TarjetaVisaId;
            evtSrc = 'EVENTSOURCING_TRANSACTION_TARJETA_CREDITO_VISA';
            localValues = {
                'ES_TARJETA_TEMPORAL': novedad.ValorNovedad
            }
            break;

        case "VIGER_TARJ":
            idEntidad = novedad.TarjetaCreditoId;
            evtSrc = 'EVENTSOURCING_TRANSACTION_TARJETA_CREDITO';
            localValues = {
                'VIGENCIA': novedad.ValorNovedad
            }
            break;
    }
    Engine1Proxy.AddEventSourcingDataRequest(localValues, evtSrc, 'Tarjetas', 'SOLICITUD', null, isQuery, null, deleteInstance, idEntidad);
    Engine1Proxy.Execute(() => { }, null, null, "SOLICITUD");
}

function getNovedadesByTipoAndId(novedadTipoId, entidadId) {
    LogHelper.In(getNovedadesByTipoAndId.name);

    const paramsNovedades = { "NOVEDAD_TIPO_ID": novedadTipoId, "ENTIDAD_ID": entidadId, "ESTADOS": "123456" }
    LogHelper.Out(getNovedadesByTipoAndId.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");

    /*si novedadTipoId es 2, quiere decir que son tarjetas entonces se debe consultar ambas novedades, las canceladas y las normales*/
    if (novedadTipoId == 2) {
        const paramsNovedadesCancelada = { "NOVEDAD_TIPO_ID": novedadTipoId, "ENTIDAD_ID": entidadId, "ESTADOS": "7" }

        /*novedades, canceladas*/
        LogHelper.Out(getNovedadesByTipoAndId.name, paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");
        Engine1Proxy.AddDataSourcesRequests(paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");
    }

    Engine1Proxy.Execute((data) => callbackNovedadesByTipoAndId(data, novedadTipoId), null, "ADMINEMPCUETAR");
}
/**
 * 
 * @param {any} data
 */
function callbackNovedadesByTipoAndId(data, novedadTipoId) {
    let novedades = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_0).Recordset0.Rows;
    let novedadesCanceladas = [];

    /*Si existe el _1 quiere decir que hay novedades canceladas de tarjetas*/
    if (data.GET_NOVEDADES_BY_TIPO_AND_ID_1) {
        novedadesCanceladas = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_1).Recordset0.Rows;
    }

    _dispatch({ type: ACTUALIZAR_ESTADO_NOVEDAD, novedades, novedadTipoId, novedadesCanceladas });
}
/**
 * 
 * @param {any} entidadTipoId
 * @param {any} novedadCampoCodigo
 * @param {any} entidadId
 */
function getNovedadesByIdAndCodigo(entidadTipoId, novedadCampoCodigo, entidadId) {
    LogHelper.In(getNovedadesByIdAndCodigo.name);

    let novedadTipoId;
    switch (entidadTipoId) {
        case 0: //Empresa
            novedadTipoId = 3
            break;
        case 1: //Cuenta
            novedadTipoId = 1
            break;
        case 2: //Tarjeta
            novedadTipoId = 2
            break;
    }

    let parametrosNovedades = {
        'NOVEDAD_TIPO_ID': novedadTipoId,
        'NOVEDAD_CAMPO_CODIGO': novedadCampoCodigo,
        'ENTIDAD_ID': entidadId
    }

    LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, parametrosNovedades, 'GET_NOVEDADES_BY_ID_AND_CODIGO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametrosNovedades, 'GET_NOVEDADES_BY_ID_AND_CODIGO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    let dataCheck = [];
    switch (novedadCampoCodigo) {
        //Empresa
        case 'BONRE_EMPR': //Bonificacion Renovacion
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_ATLAS_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            break;
        case 'CARTE_EMPR': //Carteras
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_ATLAS_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            break;
        /*Rubros de la empresa*/
        case "RUBRO_EMPR": {
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        }
        //Cuenta
        case 'SUCUR_CUEN': //Sucursales
        case 'SUCUE_CUEN': //Sucursales de Cuenta 
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            break;
        case 'MODLI_CUEN': //Modelo Liquidacion
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;
        case 'GRUPA_CUEN': //Grupo Afinidad
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;
        case 'AGRUP_CUEN': //Agrupamientos
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
            break;
        case 'FRMPG_CUEN': //Forma de Pago
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;
        case 'FRMDB_CUEN': //Importe a debitar
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;
        case 'PROMO_CUEN': //Promotor
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            break;
        case 'LINPR_CUEN': //Lineas de Prestamo
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;
        case 'CATAT_CUEN': //Categoría cajeros
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _productId, 'GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_productId, 'GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
            break;

        //Tarjeta
        case 'TITAR_TARJ': //Tipo Tarjeta
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, _params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(_params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            break;
        case 'VIGER_TARJ': //Vigencia Dias
            LogHelper.Out(callBackgetNovedadesByIdAndCodigo.name, null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
            break;

        //Check
        //Empresa
        case 'ESCON_EMPR': //Es Confidencial
        case 'NUECL_EMPR': //Nueva Clave HomeBanking
        case 'PERAD_EMPR': //Permite Adelantos
        case 'LIMTR_EMPR': //Limite de Transaccion
        case 'CONEX_EMPR': //Consumo Exterior
        case 'REPCU_EMPR': //Reporte Cuenta Central
        case 'MODLI_EMPR': //Resumen Modelo Liquidacion
        case 'ACTRE_EMPR': //Valor Renovar

        //Tarjeta
        case 'ESTEM_TARJ': //Es una Tarjeta Temporal
            // TODO: esto estaba en la función getConversionCheck(), pero la misma devuelve este dato mockeado.
            // Revisar si la función tiene que hacer algo más complejo y , de ser asi, restaurarla.
            dataCheck = [{ 'Id': 0, 'Descripcion': 'NO' }, { 'Id': 1, 'Descripcion': 'SI' }];
            break;
    }

    Engine1Proxy.Execute((data) => callBackgetNovedadesByIdAndCodigo(data, dataCheck), null, "ADMINEMPCUETAR");
}
/**
 * Callback que devuelve las novedades de empresa, cuenta o tarjeta
 * @param {any} data
 */
function callBackgetNovedadesByIdAndCodigo(data, dataCheck) {
    LogHelper.In(callBackgetNovedadesByIdAndCodigo.name, data, dataCheck);

    let getNovedadesByIdAndCodigoRecordset = JSON.parse(data.GET_NOVEDADES_BY_ID_AND_CODIGO);
    let novedadesHistoria = getNovedadesByIdAndCodigoRecordset.Recordset0.Rows;

    if (data.hasOwnProperty('GET_ATLAS_BONIFICACION_RENOVACION')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_ATLAS_BONIFICACION_RENOVACION).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_ATLAS_CARTERA')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_ATLAS_CARTERA).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_SUCURSAL')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_SUCURSAL).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PROMOTOR')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PROMOTOR).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_VIGENCIA_TARJETA')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_VIGENCIA_TARJETA).Recordset0.Rows;
    }

    if (data.hasOwnProperty('GET_RUBRO_COMERCIAL')) {
        novedadesHistoria.GET_PARAMETRIA = JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows;

        novedadesHistoria.forEach((nh) => {
            if (nh.RegistroInicial == 0) {
                const rubrosId = nh.ValorNovedad.split(",");
                let rubrosDescripcion = novedadesHistoria.GET_PARAMETRIA.filter((gp) =>
                    rubrosId.some((rb) => parseInt(rb) === gp.Id)
                );

                if (rubrosDescripcion && rubrosDescripcion.length > 0) {
                    rubrosDescripcion = rubrosDescripcion.map((rd) => rd.Descripcion).toString();
                    rubrosDescripcion = rubrosDescripcion.replace(",", ", ");

                    nh.ValorNovedadDescripcion = nh.ValorHistorico.replace(/\d/g, "").replace(",", "") + rubrosDescripcion;
                }
            }
        });
    }

    if (dataCheck.length > 0) {
        novedadesHistoria.GET_PARAMETRIA = dataCheck;
    }

    _dispatch({
        type: GET_NOVEDADES_BY_ID_AND_CODIGO,
        novedadesHistoria
    });
}

/**
 * Cargar datos de cuenta. 
 * @param {any} state 
 * @param {any} id
 */
function _loadCuentaData(state, id) {
    LogHelper.In(_loadCuentaData.name, state, id);

    let idCuenta = {
        "ID": id
    }

    let producto = state.vistaCliente.data.GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT.find(x => x.Id == id);
    let productoId = producto ? producto.ProductoId : 0;
    let productId = { 'PRODUCTO_ID': parseInt(productoId) }

    _productId = productId;

    let admId = { 'ADMINISTRADORA_ID': parseInt(producto.AdministradoraId) }

    const paramSuCuentas = {
        "PRODUCTO_ID": parseInt(productoId),
        'NUMERO_DOCUMENTO': _tarjetas.cliente.NumeroDocumento,
        'TIPO_DOCUMENTO_CODIGO': _tarjetas.cliente.TipoDocumento.Codigo
    }

    let parametroDomicilios = {
        'CLIENTE_BANCO_NUMERO': _tarjetas.cliente.ClienteBancoNumero,
        'NUMERO_DOCUMENTO': _tarjetas.cliente.NumeroDocumento.toString(),
        'TIPO_DOCUMENTO_CODIGO': _tarjetas.cliente.TipoDocumento.Codigo
    }

    let parametroListaDocumentos = {
        'NUMERO_DOCUMENTO': _tarjetas.cliente.NumeroDocumento,
        'TIPO_DOCUMENTO_CODIGO': _tarjetas.cliente.TipoDocumento.Codigo
    }

    const paramsNovedades = { "NOVEDAD_TIPO_ID": 1, "ENTIDAD_ID": id, "ESTADOS": "123456" }

    let parametroBajaCuenta = {
        'CUENTA_TARJETA_ID': id,
        'CLIENTE_ID': _tarjetas.cliente.Id
    }

    LogHelper.Out(_loadCuentaData.name, idCuenta, 'GET_CUENTA_TARJETA_VISA_BY_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(idCuenta, 'GET_CUENTA_TARJETA_VISA_BY_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");

    LogHelper.Out(_loadCuentaData.name, null, 'GET_PRODUCTOS', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PRODUCTOS', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_SUCURSAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_SUCURSAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, admId, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(admId, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_CARTERA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_CARTERA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_CODIGO_DISTRIBUCION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_CODIGO_DISTRIBUCION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, productId, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(productId, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadCuentaData.name, paramSuCuentas, 'GETCLIENTESUCURSALES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(paramSuCuentas, 'GETCLIENTESUCURSALES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    LogHelper.Out(_loadCuentaData.name, parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    LogHelper.Out(_loadCuentaData.name, parametroListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    LogHelper.Out(_loadTarjetaData.name, parametroBajaCuenta, 'GET_BAJA_CUENTA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametroBajaCuenta, 'GET_BAJA_CUENTA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    let parametroBajaCuenta2 = {
        'INDIVIDUOS_EMPRESA': 'E'
    }

    LogHelper.Out(_loadCuentaData.name, parametroBajaCuenta2, 'GET_BAJA_CUENTA_MOTIVO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametroBajaCuenta2, 'GET_BAJA_CUENTA_MOTIVO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    Engine1Proxy.Execute((data) => {
        _cargarCodigosGeograficos(data, _loadPostCuentaInitialStateData);

    }, null, null, "ADMINEMPCUETAR");
}

function _cargarCodigosGeograficos(data, callback) {
    const getClienteListadDocumentos = /*JSON.parse(data.GETCLIENTEDOMICILIOS); SE COMENTA POR NO TENER CLIENTE */[]
    let hayDomicilios = false;
    let domiciliosService = [];

    getClienteListadDocumentos.filter((dc1) => dc1.Direccion.CodigoDomicilio == "01").forEach((dc2, index) => {
        dc2.Direccion.CodigoPostal = dc2.Direccion.CodigoPostal.slice(0, 4);
        dc2.Direccion.Telefono = dc2.Telefono;

        const paramsCodPosta = {
            CODIGO_POSTAL: dc2.Direccion.CodigoPostal
        }
        /*busco todos los codigos geograficos de visa por el codigo postal del domicilio del cliente, para no traer todos los registros y llenar el state*/
        LogHelper.Out(_cargarCodigosGeograficos.name, paramsCodPosta, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product', true, 'GET_CODIGO_GEOGRAFICO_VISA_' + index);
        Engine1Proxy.AddDataSourcesRequests(paramsCodPosta, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product', true, 'GET_CODIGO_GEOGRAFICO_VISA_' + index);

        domiciliosService.push(dc2.Direccion);
        hayDomicilios = true;
    });

    data.GETCLIENTEDOMICILIOS = domiciliosService;
    data.GET_CODIGO_GEOGRAFICO = [];

    if (hayDomicilios == false) {
        callback(data);
    } else {
        Engine1Proxy.Execute(internalData => {
            Object.keys(internalData).forEach(idat => {
                if (idat.indexOf("GET_CODIGO_GEOGRAFICO_VISA_") >= 0) {
                    const result = JSON.parse(internalData[idat]).Recordset0.Rows;
                    data.GET_CODIGO_GEOGRAFICO = data.GET_CODIGO_GEOGRAFICO.concat(result);
                }
            });

            callback(data);
        }, null, null, "ADMINEMPCUETAR");
    }
}

function _loadPostCuentaInitialStateData(data) {
    LogHelper.In(_loadPostCuentaInitialStateData.name, data);

    let cuentaDatos = JSON.parse(data.GET_CUENTA_TARJETA_VISA_BY_ID).Recordset0.Rows[0];
    let novedadesCuentaDatos = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_0).Recordset0.Rows;

    //- Datos de la baja cuenta
    let bajaCuentaData = {};

    bajaCuentaData.bajaCuenta0 = JSON.parse(data.GET_BAJA_CUENTA).Recordset0.Rows[0];
    bajaCuentaData.bajaCuenta1 = JSON.parse(data.GET_BAJA_CUENTA).Recordset1.Rows[0];
    bajaCuentaData.bajaCuenta2 = JSON.parse(data.GET_BAJA_CUENTA).Recordset2.Rows[0];
    bajaCuentaData.bajaCuenta3 = JSON.parse(data.GET_BAJA_CUENTA).Recordset3.Rows[0];
    bajaCuentaData.bajaCuenta4 = JSON.parse(data.GET_BAJA_CUENTA).Recordset4.Rows[0];
    bajaCuentaData.bajaCuenta5 = JSON.parse(data.GET_BAJA_CUENTA).Recordset5.Rows[0];
    bajaCuentaData.bajaCuenta6 = JSON.parse(data.GET_BAJA_CUENTA).Recordset6.Rows[0];
    bajaCuentaData.bajaCuenta7 = JSON.parse(data.GET_BAJA_CUENTA).Recordset7.Rows[0];
    bajaCuentaData.bajaCuenta8 = JSON.parse(data.GET_BAJA_CUENTA).Recordset8.Rows[0];
    bajaCuentaData.bajaCuenta9 = JSON.parse(data.GET_BAJA_CUENTA).Recordset9.Rows[0];
    bajaCuentaData.bajaCuenta10 = JSON.parse(data.GET_BAJA_CUENTA).Recordset10.Rows[0];
    bajaCuentaData.bajaCuenta11 = JSON.parse(data.GET_BAJA_CUENTA).Recordset11.Rows[0];
    bajaCuentaData.bajaCuenta12 = JSON.parse(data.GET_BAJA_CUENTA).Recordset12.Rows[0];
    bajaCuentaData.bajaCuenta13 = JSON.parse(data.GET_BAJA_CUENTA).Recordset13.Rows[0];
    bajaCuentaData.bajaCuenta14 = JSON.parse(data.GET_BAJA_CUENTA).Recordset14.Rows[0];
    const bajaId = JSON.parse(data.GET_BAJA_CUENTA).Recordset15.Rows[0].Id;

    //bajaCuentaData.motivosBaja = JSON.parse(data.GET_ATLAS_MOTIVO_INHABILITADO).Recordset0.Rows;
    bajaCuentaData.motivosBaja = JSON.parse(data.GET_BAJA_CUENTA_MOTIVO).Recordset0.Rows;

    //- Datos del producto
    let accountData = {};
    //accountData.GET_CUENTAS_BANCARIAS = data.GET_CUENTAS_BANCARIAS;
    accountData.GET_CUENTAS_BANCARIAS = JSON.parse(data.GETCLIENTELISTADOCUMENTOS);
    accountData.GET_PRODUCTO = JSON.parse(data.GET_PRODUCTOS).Recordset0.Rows;
    accountData.GET_PROMOTOR = JSON.parse(data.GET_PROMOTOR).Recordset0.Rows;
    accountData.GET_ALL_SUCURSAL = JSON.parse(data.GET_SUCURSAL).Recordset0.Rows;
    accountData.GET_SUCURSAL = JSON.parse(data.GETCLIENTESUCURSALES) != undefined ? JSON.parse(data.GETCLIENTESUCURSALES) : [];

    accountData.GET_LIMITE_COMPRA = JSON.parse(data.GET_LIMITE_COMPRA).Recordset0.Rows;
    accountData.GET_FORMA_DEBITO = JSON.parse(data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_FORMA_PAGO = JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_MODELO_LIQUIDACION = JSON.parse(data.GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_GRUPO_AFINIDAD = JSON.parse(data.GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID).Recordset0.Rows;

    //- Producto Visa
    accountData.GET_PRODUCTO_VISA = JSON.parse(data.GET_PRODUCTO_VISA_PRODUCTO_ID).Recordset0.Rows[0];
    accountData.GET_AGRUPAMIENTO = JSON.parse(data.GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_CATEGORIA_CAJERO = JSON.parse(data.GET_PRODUCTO_CATEGORIA_ATM_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_LINEA_PRESTAMO = JSON.parse(data.GET_PRODUCTO_LINEA_PRESTAMO_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_CARTERA = JSON.parse(data.GET_PRODUCTO_CARTERA_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_MODALIDAD_DISTRIBUCION_LIMITE = JSON.parse(data.GET_PRODUCTO_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID).Recordset0.Rows;
    accountData.GET_CODIGO_GEOGRAFICO = data.GET_CODIGO_GEOGRAFICO

    accountData.LimiteFinanciacionEsModificable = accountData.GET_PRODUCTO_VISA != undefined ? accountData.GET_PRODUCTO_VISA.LimiteFinanciacionEsModificable : undefined;
    accountData.FlccEsModificable = accountData.GET_PRODUCTO_VISA != undefined ? accountData.GET_PRODUCTO_VISA.FlccEsModificable : undefined;

    let sucursalesCuentas = [];

    /*CUENTAS BANCARIAS*/
    let getClientesListadoDocumentos = JSON.parse(data.GETCLIENTELISTADOCUMENTOS);
    getClientesListadoDocumentos = getClientesListadoDocumentos.map((dp) => dp.Cuenta);

    if (getClientesListadoDocumentos) {
        //Genero las nuevas sucursales para las cuentas bancarias de forma de pago
        getClientesListadoDocumentos.forEach((cuenta, index) => {
            /*busco la sucursal por el codigo*/
            let sucursal = accountData.GET_SUCURSAL.find((sucursal) => sucursal.Codigo == cuenta.Sucursal);
            /*busco si la sucursal ya la tengo en el array de sucursales*/
            let resultado = sucursalesCuentas.some((sc) => sc.Codigo == cuenta.Sucursal);

            if (!resultado) {
                sucursalesCuentas.push({
                    Id: (sucursal) ? sucursal.Id : index,
                    Codigo: cuenta.Sucursal,
                    Descripcion: (sucursal) ? sucursal.Descripcion : ""
                });
            }
        });
    }
    /*FIN CUENTAS BANCARIAS*/

    accountData.sucursalesCuentas = sucursalesCuentas;
    accountData.domiciliosService = data.GETCLIENTEDOMICILIOS;
    cuentaDatos.accountData = accountData;
    cuentaDatos.bajaCuentaData = bajaCuentaData;

    setVistaClienteEntidad(cuentaDatos.Id, 1);

    /*domicilio correspondencia*/
    let domicilioCorrespondencia = {
        "BancoTipo": { "Valor": cuentaDatos.DomicilioCorrespondenciaBancoTipo, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaBancoTipo },
        "Calle": { "Valor": cuentaDatos.DomicilioCorrespondenciaCalle, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaCalle },
        "Caracteristica": { "Valor": cuentaDatos.Caracteristica, "ValorOriginal": cuentaDatos.Caracteristica },
        "CodigoGeografico": {
            "EsOtro": false,
            "Novedad": novedadesCuentaDatos.find(ncd => ncd.NovedadCampoCodigo == "DMCGE_CUEN"),
            "NovedadEditada": false,
            "Valor": cuentaDatos.DomicilioCorrespondenciaCodigoGeografico,
            "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaCodigoGeografico
        },
        "CodigoPostal": { "Valor": cuentaDatos.DomicilioCorrespondenciaCodigoPostal, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaCodigoPostal },
        "DepartamentoPartido": { "Valor": cuentaDatos.DomicilioCorrespondenciaDepartamentoPartido, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaDepartamentoPartido },
        "Lod": { "Valor": cuentaDatos.DomicilioCorrespondenciaLod, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaLod },
        "Numero": { "Valor": cuentaDatos.DomicilioCorrespondenciaNumero, "ValorOriginal": cuentaDatos.DomicilioCorrespondenciaNumero },
        "Telefono": { "Valor": cuentaDatos.Telefono, "ValorOriginal": cuentaDatos.Telefono }
    }

    cuentaDatos.DomicilioCorrespondencia2 = domicilioCorrespondencia;
    /*fin de domicilio correspondencia*/

    const resultadoDispatch = {
        type: ((_seleccion == "inicial") ? GET_PANEL_SELECCION_DATA : CHANGE_DATES_CUENTA_PANEL),
        vistaCliente: _vistaCliente,
        cuenta: cuentaDatos,
        novedades: novedadesCuentaDatos,
        funcionesDelUsuario,
        bajaId: bajaId,
        features: _currentScope
    }

    _dispatch({ ...resultadoDispatch });
}
//////////////

// ------------------------------------------------- EMPRESA ------------------------------------------------- //
function _loadEmpresaData(state, id) {
    LogHelper.In(_loadEmpresaData.name, state, id);

    let idEmpresa = { "ID": id }
    let parametrosCategoriaIva = { 'CATEGORIA_IVA_ID': 1 }; // MOCKEADO
    
    let parametroDomicilios = {
        'CLIENTE_BANCO_NUMERO': state.tarjetas.clienteResultadoBusqueda.CuentaCliente.NroCuenta,
        'NUMERO_DOCUMENTO': state.tarjetas.clienteResultadoBusqueda.NUMERO_DOCUMENTO.replace(/./g,""),
        'TIPO_DOCUMENTO_CODIGO': state.tarjetas.clienteResultadoBusqueda.TIPO_DOCUMENTO
    }

    const paramsNovedades = { "NOVEDAD_TIPO_ID": 3, "ENTIDAD_ID": id, "ESTADOS": "123456" }

    LogHelper.Out(_loadEmpresaData.name, idEmpresa, 'GET_EMPRESA_VISA_FULL_BY_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(idEmpresa, 'GET_EMPRESA_VISA_FULL_BY_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadEmpresaData.name, null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_RUBRO_COMERCIAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadEmpresaData.name, null, 'GET_ATLAS_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_BONIFICACION_RENOVACION', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadEmpresaData.name, null, 'GET_ATLAS_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_ATLAS_CARTERA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadEmpresaData.name, parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(parametrosCategoriaIva, 'GET_CATEGORIA_IVA_BY_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    //LogHelper.Out(_loadEmpresaData.name, parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    //Engine1Proxy.AddRuleRequests(parametroDomicilios, 'GETCLIENTEDOMICILIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute((data) => {
        _cargarCodigosGeograficos(data, _loadEmpresaInitialStateData);

    }, null, null, "ADMINEMPCUETAR");
}

function _loadEmpresaInitialStateData(data) {
    LogHelper.In(_loadEmpresaInitialStateData.name, data);

    let rubros = JSON.parse(data.GET_RUBRO_COMERCIAL).Recordset0.Rows;
    let empresaDatos = JSON.parse(data.GET_EMPRESA_VISA_FULL_BY_ID).Recordset0.Rows[0];
    let novedadesEmpresa = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID).Recordset0.Rows;
    let novedadesRubros = novedadesEmpresa.filter(x => x.NovedadCampoCodigo == "RUBEX_EMPR" || x.NovedadCampoCodigo == "RUBIN_EMPR");
    let atlasBonificacionRenovacion = JSON.parse(data.GET_ATLAS_BONIFICACION_RENOVACION).Recordset0.Rows;
    let atlasCartera = JSON.parse(data.GET_ATLAS_CARTERA).Recordset0.Rows;
    let entidadInstaciasEquivalenciaCodigoIva = JSON.parse(data.GET_CATEGORIA_IVA_BY_ID).Recordset0.Rows[0];
    
    rubros.forEach((rubro) => { rubro.selected = false; });

    if (empresaDatos) {
        if (novedadesRubros.length > 0) {
            setearRubrosNovedades(rubros, novedadesRubros, empresaDatos);
        }
        else {
            setearRubros(rubros, empresaDatos);
        }
    }

    empresaDatos.accounts = JSON.parse(JSON.stringify(_vistaCliente.data.enterprises.find(x => x.Id == empresaDatos.Id).cuentas));
    setVistaClienteEntidad(empresaDatos.Id, 0);

    const resultDispatch = {
        type: ((_seleccion == "inicial") ? GET_PANEL_SELECCION_DATA : CHANGE_DATES_EMPRESA_PANEL),
        vistaCliente: _vistaCliente,
        empresa: empresaDatos,
        novedades: novedadesEmpresa,
        rubros,
        atlasBonificacionRenovacion,
        atlasCartera,
        entidadInstaciasEquivalenciaCodigoIva,
        getCodigoGeograficoVisa: data.GET_CODIGO_GEOGRAFICO,
        funcionesDelUsuario,
        domiciliosService: data.GETCLIENTEDOMICILIOS
    }

    _dispatch({ ...resultDispatch });
}

function setVistaClienteEntidad(idEntidad, tipoEntidad) {
    LogHelper.In(setVistaClienteEntidad.name, idEntidad, tipoEntidad);

    _vistaCliente.idEntidad = idEntidad;
    _vistaCliente.tipoEntidad = tipoEntidad;
    _vistaCliente.data.idEntidad = idEntidad;
    _vistaCliente.data.tipoEntidad = tipoEntidad;
}

function setearRubrosNovedades(rubros, novedadesRubros, empresaDatos) {
    LogHelper.In(setearRubrosNovedades.name, rubros, novedadesRubros, empresaDatos);

    let solamente = novedadesRubros.find(x => x.NovedadCampoCodigo == "RUBIN_EMPR");
    let excepto = novedadesRubros.find(x => x.NovedadCampoCodigo == "RUBEX_EMPR");

    //Revisa que tipo de novedad es
    if (solamente.ValorNovedad == "" && excepto.ValorNovedad == "") {//Todos
        empresaDatos.RubroIncluidoExcluido = null;
    }
    else {
        if (solamente.ValorNovedad != "") {//Solamente
            empresaDatos.RubroIncluidoExcluido = "I";
            setearRubrosValorNovedad(rubros, empresaDatos, solamente.ValorNovedad);
        }
        else {//Excepto
            empresaDatos.RubroIncluidoExcluido = "E";
            setearRubrosValorNovedad(rubros, empresaDatos, excepto.ValorNovedad);
        }
    }
}

function setearRubrosValorNovedad(rubros, empresaDatos, valorNovedad) {
    LogHelper.In(setearRubrosValorNovedad.name, rubros, empresaDatos, valorNovedad);

    let novedades = valorNovedad.split(",");
    novedades.forEach(function (codigo) {
        setearRubroNovedad(rubros, codigo);
    });
}

function setearRubros(rubros, empresa) {
    LogHelper.In(setearRubros.name, rubros, empresa);

    setearRubro(rubros, empresa.Rubro1);
    setearRubro(rubros, empresa.Rubro2);
    setearRubro(rubros, empresa.Rubro3);
    setearRubro(rubros, empresa.Rubro4);
    setearRubro(rubros, empresa.Rubro5);
    setearRubro(rubros, empresa.Rubro6);
    setearRubro(rubros, empresa.Rubro7);
    setearRubro(rubros, empresa.Rubro8);
    setearRubro(rubros, empresa.Rubro9);
}

function setearRubroNovedad(rubros, codigo) {
    LogHelper.In(setearRubro.name, rubros, codigo);

    let rubro = rubros.find(x => x.Codigo == codigo);
    if (rubro) {
        rubro.selected = true;
    }
}

function setearRubro(rubros, idRubro) {
    LogHelper.In(setearRubro.name, rubros, idRubro);

    let rubro = rubros.find(x => x.Id == idRubro)
    if (rubro) {
        rubro.selected = true;
    }
}

/**
 * Callback que devuelve los datos de la novedad
 * @param {any} data
 */
function callBackGuardarNovedad(state) {
    LogHelper.In(callBackGuardarNovedad.name, state);

    switch (state.panelSeleccion.data.entidadTipo) {
        case 0: {
            const paramsNovedades = { "NOVEDAD_TIPO_ID": 3, "ENTIDAD_ID": state.panelSeleccion.data.empresa.Id, "ESTADOS": "123456" }

            LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");
            Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");

            break;
        }
        case 1: {
            const paramsNovedades = { "NOVEDAD_TIPO_ID": 1, "ENTIDAD_ID": state.panelSeleccion.data.cuentaDatos.Id, "ESTADOS": "123456" }

            LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");
            Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");

            break;
        }
        case 2: {
            const paramsNovedades = { "NOVEDAD_TIPO_ID": 2, "ENTIDAD_ID": state.panelSeleccion.data.cuentaDatos.Id, "ESTADOS": "123456" }
            const paramsNovedadesCancelada = { "NOVEDAD_TIPO_ID": 2, "ENTIDAD_ID": state.panelSeleccion.data.cuentaDatos.Id, "ESTADOS": "7" }

            /*novedades, completadas, confirmadas y denegadas*/
            LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_2");
            Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_2");
            /*novedades, canceladas*/
            LogHelper.Out(_loadTarjetaData.name, paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_3");
            Engine1Proxy.AddDataSourcesRequests(paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_3");
            break;
        }
        default:
    }

    Engine1Proxy.Execute((data) => _loadGetNovedadesEmpresaVisa(data, state.panelSeleccion.data.entidadTipo), null, null, "ADMINEMPCUETAR");
}

/**
 * Callback que devuelve los datos de la novedad de la base
 * @param {any} data
 */
function _loadGetNovedadesEmpresaVisa(data, entidadId) {
    LogHelper.In(_loadGetNovedadesEmpresaVisa.name, data, entidadId);
    let novedadesEmpresa;
    let novedadesCuenta;

    let novedadesTarjeta;
    let novedadesTarjetaCanceladas = [];

    switch (entidadId) {
        case 0:
            novedadesEmpresa = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_0).Recordset0.Rows;
            break;
        case 1: {
            novedadesCuenta = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_1).Recordset0.Rows;
            break;
        }
        case 2:
            novedadesTarjeta = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_2).Recordset0.Rows;
            novedadesTarjetaCanceladas = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_3).Recordset0.Rows;
            break;
        default:
    }

    _dispatch({
        type: SAVE_NOVEDAD_PANEL,
        data: novedadesEmpresa,
        dataCuenta: novedadesCuenta,
        dataTarjeta: novedadesTarjeta,
        novedadesTarjetaCanceladas,
        entidadId: entidadId
    });
}

/**
 * Comprueba valor de la novedad
 * @param {any} novedad
 */
function comprobarNovedad(novedad) {
    LogHelper.In(comprobarNovedad.name, novedad);

    switch (novedad) {
        case false:
            return 0;
        case true:
            return 1;
        case "NO":
            return 0;
        case "SI":
            return 1;
        default:
            return novedad;
    }
}

/**
 * Quita la T a la fecha
 * @param {any} fecha
 */
function convertirFecha(fecha) {
    LogHelper.In(convertirFecha.name, fecha);

    if (fecha != undefined) {
        return fecha.replace('T', ' ');
    }
    else {
        return null;
    }
}

/**
 * 
 * @param {any} valor
 * @param {any} padre
 * @param {any} campo
 */
export function guardarCampo(valor, campo, ...params) {
    LogHelper.In(guardarCampo.name, valor, campo);

    return (dispatch) => {
        dispatch({ type: GUARDAR_CAMPO_PANEL, valor, campo, params });
    }
}

//- TARJETAS
function _loadTarjetaData(getState, cuentaTarjetaId) {
    LogHelper.In(_loadTarjetaData.name, getState, cuentaTarjetaId);

    let idCuentaTarjeta = {
        "CUENTA_TARJETA_ID": cuentaTarjetaId
    }
    let cuentas = getState.vistaCliente.data.GET_CUENTA_TARJETA_CON_BAJA_BY_CUIT.find(x => x.Id == cuentaTarjetaId);
    let produtoIdcuentaSeleccionada = ((cuentas) ? cuentas.ProductoId : 0);

    let params = {
        'ADMINISTRADORA_ID': getState.tarjetas.administradora.Id,
        'PRODUCTO_ID': produtoIdcuentaSeleccionada
    }

    _params = params

    let paramsNovedades = { "NOVEDAD_TIPO_ID": 2, "ENTIDAD_ID": cuentaTarjetaId, "ESTADOS": "123456" }
    let paramsNovedadesCancelada = { "NOVEDAD_TIPO_ID": 2, "ENTIDAD_ID": cuentaTarjetaId, "ESTADOS": "7" }

    LogHelper.Out(_loadTarjetaData.name, params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, idCuentaTarjeta, 'GET_TARJETAS_CUENTA_BY_CUENTA_TARJETA_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(idCuentaTarjeta, 'GET_TARJETAS_CUENTA_BY_CUENTA_TARJETA_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    /*novedades, completadas, confirmadas y denegadas*/
    LogHelper.Out(_loadTarjetaData.name, paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");
    Engine1Proxy.AddDataSourcesRequests(paramsNovedades, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_0");

    /*novedades, canceladas*/
    LogHelper.Out(_loadTarjetaData.name, paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");
    Engine1Proxy.AddDataSourcesRequests(paramsNovedadesCancelada, 'GET_NOVEDADES_BY_TIPO_AND_ID', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product', true, "GET_NOVEDADES_BY_TIPO_AND_ID_1");

    LogHelper.Out(_loadTarjetaData.name, null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_VIGENCIA_TARJETA', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, null, 'GET_LIMITE_COMPRA_MIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_LIMITE_COMPRA_MIN', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, null, 'GET_TARJETAS_BLOQUEO_MOTIVO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_TARJETAS_BLOQUEO_MOTIVO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    LogHelper.Out(_loadTarjetaData.name, null, 'GET_TARJETA_BAJA_MOTIVO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_TARJETA_BAJA_MOTIVO', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');

    Engine1Proxy.Execute((data) => _loadTarjetasInitialStateData(data, getState, cuentaTarjetaId), null, null, "ADMINEMPCUETAR");
}

function _loadTarjetasInitialStateData(data, getState, cuentaTarjetaId) {
    LogHelper.In(_loadTarjetasInitialStateData.name, data, getState, cuentaTarjetaId);

    let tarjetas = JSON.parse(data.GET_TARJETAS_CUENTA_BY_CUENTA_TARJETA_ID).Recordset0.Rows;

    let novedadesTarjetaDatos = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_0).Recordset0.Rows;
    let novedadesTarjetaDatosCanceladas = JSON.parse(data.GET_NOVEDADES_BY_TIPO_AND_ID_1).Recordset0.Rows;

    let vigenciaTarjeta = JSON.parse(data.GET_VIGENCIA_TARJETA).Recordset0.Rows;
    let minimoValorLimite = JSON.parse(data.GET_LIMITE_COMPRA_MIN).Recordset0.Rows[0].Valor;
    let tipoTarjetas = JSON.parse(data.GET_TIPO_TARJETA_ADMINISTRADORA_PRODUCTO).Recordset0.Rows;

    tarjetas.motivos = JSON.parse(data.GET_TARJETAS_BLOQUEO_MOTIVO).Recordset0.Rows;
    tarjetas.motivosBaja = JSON.parse(data.GET_TARJETA_BAJA_MOTIVO).Recordset0.Rows;

    if (_seleccion == "inicial") {
        _dispatch({
            type: GET_PANEL_SELECCION_DATA,
            vistaCliente: _vistaCliente,
            tarjetas: tarjetas,
            novedades: novedadesTarjetaDatos,
            novedadesCanceladas: novedadesTarjetaDatosCanceladas,
            vigenciaTarjeta: vigenciaTarjeta,
            minimoValorLimite: minimoValorLimite,
            tipoTarjetas: tipoTarjetas,
            funcionesDelUsuario
        });
    }
    else {

        let cuenta = getState.panelSeleccion.data.empresa.accounts.find((cuenta) => cuenta.Id == cuentaTarjetaId);

        _dispatch({
            type: CHANGE_DATES_TARJETA_PANEL,
            vistaCliente: _vistaCliente,
            cuenta: cuenta,
            tarjetas: tarjetas,
            novedades: novedadesTarjetaDatos,
            novedadesCanceladas: novedadesTarjetaDatosCanceladas,
            vigenciaTarjeta: vigenciaTarjeta,
            minimoValorLimite: minimoValorLimite,
            tipoTarjetas: tipoTarjetas,
            funcionesDelUsuario
        });
    }
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/PanelSeleccion/actions/PanelSeleccionActions.js